class CalypsoRecommendationsGrid {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.container.addEventListener('click', this.handleClick.bind(this));

    if (this.container.dataset.equalizeMobileHeights === 'true') {
      this.initHeightEqualization();
    }
  }

  handleClick(event) {
    const swatch = event.target.closest('.cp-swatch');

    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      this.handleSwatchClick(swatch);
      return;
    }

    const form = event.target.closest('.cp-product-form');

    if (form && event.target.closest('.cp-add-to-cart-btn')) {
      if (window.PXUTheme && window.PXUTheme.theme_settings.cart_action === 'ajax') return;
      event.preventDefault();
      this.handleFormSubmit(form);
    }
  }

  handleSwatchClick(swatch) {
    const card = swatch.closest('.cp-product-card');

    if (!card || !card.dataset.productVariants) return;

    const variants = JSON.parse(card.dataset.productVariants);
    const selectedValue = swatch.dataset.value;
    const selectedVariant = variants.find(
      variant =>
        variant.option1 === selectedValue ||
        variant.option2 === selectedValue ||
        variant.option3 === selectedValue,
    );

    if (!selectedVariant) return;

    this.updateVariantId(card, selectedVariant.id);
    this.updateImage(card, selectedVariant.featured_image);
    this.updatePrice(card, selectedVariant);
    this.updateAddToCartButton(card, selectedVariant);
    this.updateActiveSwatch(swatch);
  }

  updateVariantId(card, variantId) {
    const hiddenInput = card.querySelector('input[name="id"]');

    if (hiddenInput) {
      hiddenInput.value = variantId;
    }
  }

  updateImage(card, featuredImage) {
    const primaryImage = card.querySelector('.cp-primary-image');

    if (!primaryImage) return;

    if (featuredImage && featuredImage.src) {
      primaryImage.src = featuredImage.src;
    } else {
      const originalSrc = primaryImage.dataset.originalSrc || primaryImage.src;
      primaryImage.dataset.originalSrc = originalSrc;
      primaryImage.src = originalSrc;
    }
  }

  updatePrice(card, variant) {
    const priceEl = card.querySelector('.cp-product-price .price');
    const comparePriceEl = card.querySelector('.cp-product-price .compare-at-price');
    const moneyFormat = this.container.dataset.moneyFormat || '${{amount}}';
    const storefrontMoneyFormatter =
      window.PXUTheme &&
      window.PXUTheme.currency &&
      typeof window.PXUTheme.currency.formatMoneyNoTrailingZeros === 'function'
        ? window.PXUTheme.currency.formatMoneyNoTrailingZeros
        : Shopify.formatMoney;

    if (priceEl) {
      priceEl.innerHTML = storefrontMoneyFormatter(variant.price, moneyFormat);
    }

    if (comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML = storefrontMoneyFormatter(variant.compare_at_price, moneyFormat);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
  }

  updateAddToCartButton(card, variant) {
    const atcButton = card.querySelector('.cp-add-to-cart-btn');

    if (!atcButton) return;

    const atcButtonText = atcButton.querySelector('.btn-text');
    const addToCartText = this.container.dataset.addToCartText || 'Add to cart';
    const soldOutText = this.container.dataset.soldOutText || 'Sold out';

    if (variant.available) {
      atcButton.disabled = false;
      atcButtonText.textContent = addToCartText;
    } else {
      atcButton.disabled = true;
      atcButtonText.textContent = soldOutText;
    }
  }

  updateActiveSwatch(activeSwatch) {
    const swatchContainer = activeSwatch.parentElement;

    swatchContainer.querySelectorAll('.cp-swatch').forEach(swatch => swatch.classList.remove('active'));
    activeSwatch.classList.add('active');
  }

  handleFormSubmit(form) {
    const submitButton = form.querySelector('.cp-add-to-cart-btn');

    if (!submitButton || submitButton.disabled) return;

    const btnText = submitButton.querySelector('.btn-text');
    const originalText = btnText.textContent;
    const variantId = form.querySelector('[name="id"]').value;
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    btnText.textContent = 'Adding...';
    submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status >= 400) {
          btnText.textContent = data.description || 'Error adding';
          setTimeout(() => {
            submitButton.disabled = false;
            btnText.textContent = originalText;
          }, 3000);
          return;
        }

        btnText.textContent = 'Added!';
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
          }),
        );

        setTimeout(() => {
          submitButton.disabled = false;
          btnText.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error(error);
        btnText.textContent = 'Request failed';
        setTimeout(() => {
          submitButton.disabled = false;
          btnText.textContent = originalText;
        }, 3000);
      });
  }

  equalizeMobileCardHeights() {
    const itemsPerRow = parseInt(this.container.dataset.mobileProductsPerRow || '2', 10);
    const isMobile = window.innerWidth < 769;
    const productCards = this.container.querySelectorAll('.cp-product-card');

    productCards.forEach(card => {
      card.style.height = 'auto';
    });

    if (!isMobile || itemsPerRow <= 1) {
      return;
    }

    for (let index = 0; index < productCards.length; index += itemsPerRow) {
      const rowCards = Array.from(productCards).slice(index, index + itemsPerRow);
      let maxHeight = 0;

      rowCards.forEach(card => {
        if (card.offsetHeight > maxHeight) {
          maxHeight = card.offsetHeight;
        }
      });

      rowCards.forEach(card => {
        card.style.height = `${maxHeight}px`;
      });
    }
  }

  initHeightEqualization() {
    this.equalizeMobileCardHeights();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.equalizeMobileCardHeights();
      }, 250);
    });
  }
}

function getRecommendationsRoot(element) {
  if (!element) return null;

  if (element.matches && element.matches('[data-calypso-recommendations-root], [data-calypso-grid-root]')) {
    return element;
  }

  return element.querySelector('[data-calypso-recommendations-root], [data-calypso-grid-root]');
}

function initializeCalypsoDynamicGrid(element) {
  const gridRoot = getRecommendationsRoot(element);

  if (!gridRoot || gridRoot.dataset.calypsoRecommendationsInitialized === 'true') {
    return false;
  }

  if (!gridRoot.querySelector('.cp-product-card')) {
    return false;
  }

  new CalypsoRecommendationsGrid(gridRoot);
  gridRoot.dataset.calypsoRecommendationsInitialized = 'true';
  return true;
}

function observeCalypsoDynamicGrid(sectionElement) {
  if (!sectionElement) return;

  const observer = new MutationObserver((mutationsList, obs) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0 && initializeCalypsoDynamicGrid(sectionElement)) {
        obs.disconnect();
        return;
      }
    }
  });

  observer.observe(sectionElement, {
    childList: true,
    subtree: true,
  });

  if (initializeCalypsoDynamicGrid(sectionElement)) {
    observer.disconnect();
  }
}

const CALYPSO_DYNAMIC_GRID_SECTION_CLASSES = [
  'shopify-section--recommended-products',
  'shopify-section--cp-recommended-products',
  'shopify-section--cp-recently-viewed-products',
];

function isCalypsoDynamicGridSection(element) {
  if (!element || !element.classList) return false;
  return CALYPSO_DYNAMIC_GRID_SECTION_CLASSES.some(sectionClass => element.classList.contains(sectionClass));
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll(CALYPSO_DYNAMIC_GRID_SECTION_CLASSES.map(sectionClass => `.${sectionClass}`).join(', '))
    .forEach(section => observeCalypsoDynamicGrid(section));
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    if (isCalypsoDynamicGridSection(event.target)) {
      observeCalypsoDynamicGrid(event.target);
    }
  });

  document.addEventListener('shopify:section:select', event => {
    if (isCalypsoDynamicGridSection(event.target)) {
      observeCalypsoDynamicGrid(event.target);
    }
  });
}

window.initializeCalypsoDynamicGrid = initializeCalypsoDynamicGrid;
